export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] lg:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20interior%20with%20warm%20golden%20ambient%20lighting%2C%20dark%20elegant%20atmosphere%2C%20rows%20of%20plush%20red%20seats%2C%20massive%20screen%20glowing%20softly%2C%20art%20deco%20architectural%20details%2C%20dramatic%20curved%20ceiling%2C%20luxurious%20cinema%20experience%2C%20deep%20rich%20colors%2C%20atmospheric%20fog%2C%20professional%20photography&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt="80s电影网影院级观影体验"
          className="w-full h-full object-cover object-center"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-background-50"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-28">
        <div className="w-full max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <p className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 text-primary-400 text-sm font-medium mb-6 whitespace-nowrap">
              <i className="ri-fire-line"></i>
              每日更新 · 蓝光画质 · 免费在线看
            </p>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-50 leading-tight mb-4">
              80s电影网
              <br className="md:hidden" />
              <span className="text-primary-500"> — 高清在线看免费不卡</span>
            </h1>

            <p className="text-lg md:text-xl text-primary-400 font-heading tracking-wide mb-6">
              蓝光画质搭配极速播引擎，点开即播不缓冲
            </p>

            <p className="text-foreground-300 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              80s电影网收录超10万部高清影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容。
              自研极速播引擎搭配全球CDN节点，实现点开即播、拖动秒响应。编辑团队每日中午与晚间双批次更新热片，
              蓝光画质搭配HDR色彩增强，为您呈现沉浸式影院级观影感受。无论悬疑烧脑还是江湖风云，
              打开80s电影网，好片即刻开场。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <p className="text-primary-500 text-2xl md:text-3xl font-bold font-heading">10万+</p>
                <p className="text-foreground-400 text-xs mt-1">海量片库</p>
              </div>
              <div className="w-px h-10 bg-foreground-700/30"></div>
              <div className="text-center">
                <p className="text-primary-500 text-2xl md:text-3xl font-bold font-heading">200+</p>
                <p className="text-foreground-400 text-xs mt-1">全球CDN节点</p>
              </div>
              <div className="w-px h-10 bg-foreground-700/30"></div>
              <div className="text-center">
                <p className="text-primary-500 text-2xl md:text-3xl font-bold font-heading">日更2次</p>
                <p className="text-foreground-400 text-xs mt-1">准时更新</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.getElementById('cards');
                  if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观影
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.getElementById('ranking');
                  if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-background-100/70 hover:bg-background-200/70 border border-foreground-700/30 text-foreground-200 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px] shrink-0">
            <div className="relative rounded-2xl overflow-hidden border border-background-200/40">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20collage%20style%20with%20dramatic%20warm%20golden%20lighting%2C%20film%20reel%20and%20clapperboard%20elements%2C%20silhouetted%20figures%20in%20dynamic%20poses%2C%20deep%20crimson%20and%20amber%20accents%2C%20theatrical%20velvet%20curtain%20frame%2C%20elegant%20composition%2C%20premium%20cinema%20aesthetic%2C%20rich%20textures&width=900&height=1200&seq=hero-visual&orientation=portrait"
                alt="80s电影网 — 高清蓝光极速播放"
                className="w-full h-auto object-cover"
                loading="eager"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-5">
                <p className="text-foreground-100 text-sm font-medium">
                  蓝光画质 · 极速播放 · 无需等待
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}